<template>
    <div>
        <v-autocomplete
            label="Add team"
            class="mb-6"
            rounded
            filled
            hide-details
            :items="filteredTeams"
            :item-text="(item) => `${item.name}`"
            @input="(item) => addToTeam(item.id)"
            return-object
            v-model="selectedTeam"
            :disabled="disabled"
            data-cy="add_to_team"
        ></v-autocomplete>
        <v-list v-if="userTeams.length">
            <v-list-item v-for="team of userTeams" :key="team.id">
                <v-list-item-avatar>
                    <v-avatar class="text-h4 white--text" color="primary lighten-2">
                        <v-icon>mdi mdi-account-multiple</v-icon>
                    </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                        <router-link :to="{ name: 'team', params: { teamId: team.id } }">
                            {{ team.name }}
                        </router-link>
                    </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                    <v-btn
                        @click.stop="removeFromTeam(team.id)"
                        xicon
                        depressed
                        rounded
                        color="secondary"
                        :disabled="disabled"
                        class="text-h4"
                        data-cy="remove_from_team"
                    >
                        <v-icon left>mdi mdi-delete</v-icon>
                        Remove from team
                    </v-btn>
                </v-list-item-icon>
            </v-list-item>
        </v-list>
        <div class="mt-12 text-center text--secondary" v-else>This user is not in any teams</div>
    </div>
</template>

<script>
import { teamService } from "@/services/team";
import { userService } from "@/services/user";

export default {
    name: "user-teams",
    components: {},
    props: {
        customerId: {
            type: Number,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        disabled: {
            type: Boolean,
        },
    },
    data() {
        return {
            userTeams: [],
            teams: [],
            selectedTeam: null,
        };
    },
    computed: {
        filteredTeams() {
            return this.teams.filter((t) => !this.userTeams.some((ut) => t.id === ut.id));
        },
    },
    created() {},
    async mounted() {
        await this.refreshUserTeams();
        await this.refreshTeams();
    },
    destroyed() {},
    methods: {
        async refreshTeams() {
            this.teams = await teamService.find({
                params: { customer: this.$props.customerId },
            });
        },
        async refreshUserTeams() {
            const userRes = await userService.get(this.userId);
            this.userTeams = userRes.teams;
        },
        async removeFromTeam(teamId) {
            await teamService.removeUser(teamId, this.userId);
            await this.refreshUserTeams();
        },
        async addToTeam(teamId) {
            this.$nextTick(() => {
                // Clear the input
                this.selectedTeam = null;
            });
            await teamService.addUser(teamId, this.userId);
            await this.refreshUserTeams();
        },
    },
};
</script>
